<!-- TODO: Add kind as Stepper to fix previous and next issues - the logic is already done - just didn't want to do this without testing -->
<lib-tab-group-body
    (animationDone)="AnimationDone()">
    @for (step of steps; track step.name) {
        <lib-tab [name]="step.name">
            <ng-template #tabContent>
                <!-- This height-less div is used to help with the scroll -->
                <div [id]="step.name" [attr.data-sb-qa]="step.qaTag"></div>
                <ng-container *ngTemplateOutlet="step.content"></ng-container>

            </ng-template>
        </lib-tab>
    }
</lib-tab-group-body>
